import { ComponentRef, inject, Injectable, Type, ViewContainerRef } from '@angular/core';
import { InputItemModel } from '@libs/form/models';
import { DYNAMIC_INPUT_ITEMS_MAP, DynamicInputItemsMap, InputBaseComponent } from '../../../models';

@Injectable()
export class DynamicInputItemFactoryService {
  private readonly itemsMap: DynamicInputItemsMap = inject(DYNAMIC_INPUT_ITEMS_MAP);
  private readonly viewContainerRef: ViewContainerRef = inject(ViewContainerRef);

  public createFormElement(item: InputItemModel): InputBaseComponent {
    this.viewContainerRef.clear();

    const type: Type<InputBaseComponent> | undefined = this.itemsMap[item.type];

    if (!type) {
      throw new Error(
        `Form component for item type '${item.type}' is not defined`,
      );
    }

    const componentRef: ComponentRef<InputBaseComponent> = this.viewContainerRef.createComponent(type, {
      injector: this.viewContainerRef.injector,
    });

    componentRef.setInput('data', item);
    componentRef.changeDetectorRef.detectChanges();

    return componentRef.instance;
  }
}
